import { StaticQuery, graphql } from "gatsby";
import React from "react";
import { css } from "styled-components";
import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// import DistribBg from "images/Distrib.png";

const headerStyles = css`
  @media screen and (min-width: ${getSize("desktop1920")}) {
    width: 434px;
  }
`;

const paragraphStyles = css`
  @media screen and (min-width: ${getSize("desktop1920")}) {
    width: 464px;
  }
`;

export const EnergyGenerationAndDistribution = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query EnergyGenerationAndDistributionHeroImageQuery {
          file(relativePath: { eq: "Distrib.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          css={`
            + picture > img,
            img {
              object-position: 65% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 45% 50%;
              }
            }
          `}
          alt="Powerlines silhouetted by a sunset"
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 31px 46px 47px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          padding: 41px 46px 43px 46px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 41px 46px 50px 46px;
        }
      `}
    >
      <Header2 css={headerStyles}>
        {"Energy Generation and Distribution"}
        <Underlined />
      </Header2>
      <Paragraph css={paragraphStyles}>
        {
          "Aging infrastructure, increasing power outages and growing concern for the environment are all driving the modernization of the utility grid. These factors, combined with an increase in renewable generation, are forcing a paradigm shift in power distribution and consumption to lower cost and provide resiliency."
        }
      </Paragraph>
    </Card>
  </Section>
);
